import FormEditProfile from "../../components/Forms/FormEditProfile"


export default function ProfileEditPage() {
    return (
    <>
        <FormEditProfile />
    </>)
}